import { Injectable } from '@angular/core'

import { WebSocketSubject } from 'rxjs/webSocket'

import { ChatDirectSendBody, ChatDirectSendMessage, ChatSendBody, ChatSendMessage, Message } from '@mmocld/message'

import { WsService } from '../api/ws.service'

@Injectable({
  providedIn: 'root',
})
export class ChatService {
  constructor(private wsService: WsService) {}

  sendBroadcastMessage(ws: WebSocketSubject<Message>, body: ChatSendBody) {
    this.wsService.send(ws, <ChatSendMessage>{
      action: '/chat/broadcast',
      body: body,
    })
  }

  sendRoomMessage(ws: WebSocketSubject<Message>, body: ChatSendBody) {
    this.wsService.send(ws, <ChatSendMessage>{
      action: '/chat/room',
      body: body,
    })
  }

  sendDirectMessage(ws: WebSocketSubject<Message>, body: ChatDirectSendBody) {
    this.wsService.send(ws, <ChatDirectSendMessage>{
      action: '/chat/directmessage',
      body: body,
    })
  }
}
